export default "__VITE_ASSET__CMNRzxAO__"